const $inject = [
  "$scope",
  "$uibModalInstance",
  "ClinicService",
  "clinic",
  "reset_api_key"
];

class ClinicApiKeyModalController {
  constructor(
    $scope,
    $uibModalInstance,
    ClinicService,
    clinic,
    reset_api_key
  ) {
    this.$scope = $scope;
    this.$uibModalInstance = $uibModalInstance;
    this.clinicService = ClinicService;
    this.clinic = clinic;
    this.reset_api_key = reset_api_key;

    this.loading = false;

    $scope.clinic = clinic;
  }

  cancel() {
    this.$uibModalInstance.dismiss("cancel");
  }

  generate_api_key() {
    let self = this;

    let handle_success = function (response) {
      if (response.data.success) {
        self.$uibModalInstance.close(response.data.data.api_key);
        this.loading = false;
      }
      else {
        handle_error(response);
      }
    };

    let handle_error = function (response) {
      this.loading = false;
    };

    this.reset_api_key();
    this.loading = true;
    this.clinicService.api_key(this.clinic.id, handle_success, handle_error);
  }
}

ClinicApiKeyModalController.$inject = $inject;
export default ClinicApiKeyModalController;



/** WEBPACK FOOTER **
 ** D:/server/Apache24/htdocs/hmr/app/HMRX_App/scripts/src/admin/controllers/modals/clinic-api-key.controller.js
 **/